import { Spacing } from '@genial/design-tokens';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { ScrollView, View } from 'native-base';
import React from 'react';

import { SignedInRootStackParamList } from '../../routes/types';

import { ManagementAnalysisDetailsContent } from './components/ManagementAnalysisDetailsContent';

export const ManagementAnalysisDetails: React.FC<
  NativeStackScreenProps<SignedInRootStackParamList, 'ManagementAnalysisDetails'>
> = ({ route, navigation }) => {
  const { params } = route;

  if (!params?.product || !params?.distributionProductInformation) {
    return null;
  }

  const handleBack = () => {
    navigation.navigate('AppDrawer', {
      screen: 'ManagementAnalysis',
    });
  };

  return (
    <ScrollView>
      <View
        h="full"
        width="100%"
        minW="container"
        flex={1}
        px={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.sm'], lg: Spacing['inline.sm'] }}>
        <ManagementAnalysisDetailsContent
          information={params.distributionProductInformation}
          product={params.product}
          alertText={params.alertText || ''}
          handleBack={handleBack}
        />
      </View>
    </ScrollView>
  );
};
